import { createFileRoute } from "@tanstack/react-router";

import { HubIndexPage, hubQuery } from "@/components/hubs/HubIndexPage";
import { hubIndexHead } from "@/lib/hub-seo";

const PATH = "/fi/restaurants";

export const Route = createFileRoute("/fi/restaurants/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(hubQuery("restaurants")),
  head: ({ loaderData }) =>
    hubIndexHead({
      path: PATH,
      locale: "fi",
      loaderData,
      fallbackTitle: 'Ravintolat Suomessa — keittiöt, hinnat, aukioloajat | what Finland',
      fallbackDescription: 'Selaa suomalaisia ravintoloita keittiön, hintatason ja alueen mukaan.',
      listName: 'Ravintolat Suomessa',
    }),
  component: () => <HubIndexPage slug="restaurants" locale="fi" />,
});
